module.exports = __webpack_public_path__ + "static/media/pin_third_party.3695ef48.svg";